interface SuggestionChipsProps {
  onSelect: (text: string) => void;
}

const suggestions = [
  'Set up my whole house',
  'Set up my kitchen',
  'Add a bathroom',
  'What tasks do I have?',
];

export function SuggestionChips({ onSelect }: SuggestionChipsProps) {
  return (
    <div className="flex flex-col items-center gap-4 px-4 py-8">
      <p className="text-sm font-semibold text-muted-foreground">Try asking:</p>
      <div className="flex flex-wrap gap-2 justify-center">
        {suggestions.map((text) => (
          <button
            type="button"
            key={text}
            onClick={() => onSelect(text)}
            className="min-h-[40px] px-4 py-2 rounded-full text-sm font-semibold bg-accent text-accent-foreground hover:bg-accent/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}
